import { 
    CREATE_ASSESSMENT_SUCCESS,
    SET_ALL_ASSESSMENTS,
    SET_ASSESSMENT_BY_ID,
    SET_ACTIVATE_ASSESSMENT_SUCCESS
 } from "./AssessmentTypes";

 const reducers = (state = [], action: any) => {
    switch (action.type) {
        case CREATE_ASSESSMENT_SUCCESS:
            return {
                ...state,
                assessmentCreated: action.flag,
            };
        case SET_ALL_ASSESSMENTS:
            return {
                ...state,
                allAssessmentsList: action.assessmentsList,
            };
        case SET_ASSESSMENT_BY_ID:
            return {
                ...state,
                assessmentById: action.assessmentById,
            };
        case SET_ACTIVATE_ASSESSMENT_SUCCESS:
            return {
                ...state,
                assessmentActivated: action.flag,
            };    
        default:
            return state;
    }
}

export default reducers